import React from "react";
import { NOTAM } from "@weatheredstrip/shared";
import { useGpsNotams } from "../../../../../context/gpsNotam";
import { convertFirestoreNotamFeatureToNotam } from "../../../utils";

// TODO: Be more specific with the types
function GpsNotams() {
  const { data: gpsData } = useGpsNotams();

  const notams: NOTAM[] = gpsData.map((gpsNotam) =>
    convertFirestoreNotamFeatureToNotam(gpsNotam)
  );

  if (notams !== null) {
    return notams.map((notam) => (
      <div className="notif-text" key={notam.title}>
        <div>
          <strong>{notam.title}</strong>
        </div>
        <div>{notam.notam}</div>
      </div>
    ));
  } else {
    return null;
  }
}

export default GpsNotams;
